/** Billing / plans resource (dashboard, admin-gated). */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';

export interface Plan {
  tier: string;
  name: string;
  maxAgents: number | null;
  dailyConversations: number | null;
  support: string;
  trialDays: number;
  priceUsd: number | null;
  features: string[];
}

export interface BillingStatus {
  plan: string;
  planName: string;
  planStatus: string | null;
  trialEndsAt: string | null;
  agentsUsed: number;
  agentsLimit: number | null;
  conversationsToday: number;
  conversationsLimit: number | null;
  billingEnabled: boolean;
  /** When the paid subscription ends (cancel scheduled); null unless a cancellation is pending. */
  cancelAt?: string | null;
  /** Last moment service stays active (period end + grace); null unless cancelling. */
  accessUntil?: string | null;
  billingSource?: string;
}

export interface CheckoutResult {
  checkoutUrl?: string | null;
  appliedPlan?: string | null;
}

export interface CancelResult {
  status: string; // "canceled" (immediate) | "canceling" (grace scheduled)
  immediate: boolean;
  accessUntil?: string | null;
  cancelAt?: string | null;
}

export class BillingResource {
  constructor(private readonly http: HttpClient) {}

  plans(): Promise<Plan[]> {
    return this.http.get(endpoints.billing.plans());
  }
  status(): Promise<BillingStatus> {
    return this.http.get(endpoints.billing.status());
  }
  /** Start an upgrade to `tier`: returns a Stripe checkout URL, or the applied plan (dev mode). */
  checkout(tier: string): Promise<CheckoutResult> {
    return this.http.post(endpoints.billing.checkout(), { tier });
  }
  /** Cancel the current plan (trial → immediate Free; paid → active until period end + grace). */
  cancel(): Promise<CancelResult> {
    return this.http.post(endpoints.billing.cancel());
  }
}
